import { useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';
import Header from '../Componenents/layout/header';



const HeroWrapper = styled.div`
  position: relative;
  height: 580px;
  overflow: hidden;
  background: #1a1008;
`;

const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.7;
`;

const HeroOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.75), transparent);
  padding: 60px 40px 30px;
`;

const HeroTitle = styled.h1`
  color: white;
  font-size: 2.8rem;
  font-family: serif;
  margin: 0 0 10px;
  line-height: 1.2;
`;

const HeroLocation = styled.div`
  color: #ddd;
  font-family: sans-serif;
  margin-bottom: 18px;
`;

const TagsRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
`;

const Tag = styled.span`
  padding: 8px 20px;
  border-radius: 4px;
  color: white;
  font-family: sans-serif;
  font-size: 0.9rem;
  background: #6b4c2a;
`;

const HeroPrice = styled.div`
  color: white;
  font-size: 1.8rem;
  font-weight: bold;
  font-family: sans-serif;
`;


const StatsBar = styled.div`
  background: #5c3d1e;
  padding: 18px 40px;
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
`;

const StatItem = styled.div`
  color: white;
  font-family: sans-serif;
  font-size: 0.9rem;
`;



const DescSection = styled.section`
  padding: 40px;
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
`;

const DescLeft = styled.div`
  flex: 2;
  min-width: 300px;
`;

const SectionTitle = styled.h2`
  font-size: 1rem;
  font-family: sans-serif;
  margin-bottom: 12px;
`;

const DescText = styled.p`
  color: #444;
  font-family: sans-serif;
  line-height: 1.7;
  margin-bottom: 24px;
`;

const FeatureItem = styled.div`
  font-family: sans-serif;
  margin-bottom: 12px;
`;

const ReadMoreBtn = styled.button`
  background: #5c3d1e;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-family: sans-serif;
  font-size: 0.9rem;
  margin-top: 16px;
`;

const AgentCard = styled.div`
  background: #3d2510;
  border-radius: 10px;
  padding: 24px;
  color: white;
  min-width: 220px;
  flex: 0 0 240px;
`;

const AgentName = styled.div`
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 4px;
`;

const AgentRole = styled.div`
  font-size: 0.8rem;
  color: #bbb;
  margin-bottom: 16px;
`;

const AgentPhone = styled.div`
  font-size: 0.85rem;
  margin-bottom: 16px;
`;

const ContactBtns = styled.div`
  display: flex;
  gap: 8px;
`;

const WaBtn = styled.button`
  background: #25d366;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-family: sans-serif;
`;

const EmailBtn = styled.button`
  background: #555;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-family: sans-serif;
`;



const GallerySection = styled.section`
  padding: 0 40px 40px;
`;

const TabsRow = styled.div`
  display: flex;
  margin-bottom: 20px;
  border-bottom: 2px solid #ddd;
`;

const Tab = styled.button`
  padding: 10px 24px;
  border: none;
  cursor: pointer;
  font-family: sans-serif;
  font-size: 0.9rem;
  background: ${(props) => props.active ? '#3d2510' : '#f0ebe5'};
  color: ${(props) => props.active ? 'white' : '#555'};
`;

const ImagesRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const GalleryImg = styled.img`
  width: calc(20% - 8px);
  min-width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
`;



const FloorSection = styled.section`
  padding: 0 40px 40px;
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
`;

const FloorLeft = styled.div`
  flex: 2;
  min-width: 300px;
`;

const FloorTabsRow = styled.div`
  display: flex;
  margin-bottom: 20px;
  border-bottom: 2px solid #ddd;
`;

const FloorTab = styled.button`
  padding: 10px 18px;
  border: 1px solid #ccc;
  cursor: pointer;
  font-family: sans-serif;
  font-size: 0.85rem;
  background: ${(props) => props.active ? '#3d2510' : '#f0ebe5'};
  color: ${(props) => props.active ? 'white' : '#555'};
`;

const FloorContent = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const FloorImg = styled.img`
  width: 160px;
  height: 160px;
  object-fit: cover;
  border-radius: 8px;
`;

const InfoCardsRow = styled.div`
  flex: 1;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const InfoCard = styled.div`
  background: #f5f0eb;
  border-radius: 6px;
  padding: 12px 14px;
  min-width: 140px;
  flex: 1;
`;

const InfoCardTitle = styled.div`
  font-weight: bold;
  font-family: sans-serif;
  font-size: 0.8rem;
  margin-bottom: 6px;
`;

const InfoCardItem = styled.div`
  font-size: 0.75rem;
  color: #555;
  font-family: sans-serif;
  margin-bottom: 3px;
`;

const AmenitiesCard = styled.div`
  background: #3d2510;
  border-radius: 10px;
  padding: 24px;
  color: white;
  min-width: 180px;
  flex: 0 0 200px;
`;

const AmenitiesTitle = styled.div`
  font-weight: bold;
  font-family: sans-serif;
  margin-bottom: 16px;
`;

const AmenityItem = styled.div`
  background: rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 10px;
  font-family: sans-serif;
  font-size: 0.9rem;
`;


function Home() {
  const [galleryTab, setGalleryTab] = useState('Photo Gallery');
  const [floorTab, setFloorTab] = useState('Floor plan');

  
  return (
    <div>
      < Header />

      <HeroWrapper>
        <HeroImage
          src=""
          alt="Luxury Villa"
        />
        <HeroOverlay>
          <HeroTitle>
            Luxury Modern villa <br /> in New Cairo
          </HeroTitle>
          <HeroLocation>📍 New Cairo , Egypt</HeroLocation>
          <TagsRow>
            <Tag>For Sale</Tag>
            <Tag>Luxury Villa</Tag>
            <Tag>Featured</Tag>
          </TagsRow>
          <HeroPrice>20,000,000 EGP</HeroPrice>
        </HeroOverlay>
      </HeroWrapper>

      
      <StatsBar>
        <StatItem>🛏 4 Bedrooms</StatItem>
        <StatItem>🚿 4 Bathrooms</StatItem>
        <StatItem>📐 350 sqm</StatItem>
        <StatItem>🚗 2 parking</StatItem>
        <StatItem>🏗 Built 2020</StatItem>
      </StatsBar>


      <DescSection>
        <DescLeft>
          <SectionTitle>Property Description</SectionTitle>
          <DescText>
            This stunning villa offers a blend of modern design and luxury comfort,
            featuring spacious living areas, a gourmet kitchen, and a private garden
            with a pool. It is an ideal home for families.
          </DescText>

          <FeatureItem>1- Elegant interiors and Finishes</FeatureItem>
          <FeatureItem>2- Private Swimming pool</FeatureItem>
          <FeatureItem>3- Prime Location in New Cairo</FeatureItem>

          <ReadMoreBtn>📋 Read More</ReadMoreBtn>
        </DescLeft>

        <AgentCard>
          <div style={{ fontSize: '0.85rem', color: '#ccc', marginBottom: '6px' }}>
            Contact Agent
          </div>
          <AgentName>Sarah Ahmed</AgentName>
          <AgentRole>Senior Agent</AgentRole>
          <AgentPhone>📞 +01210997444</AgentPhone>
          <ContactBtns>
            <WaBtn>💬 Whatsapp</WaBtn>
            <EmailBtn>✉ Email</EmailBtn>
          </ContactBtns>
        </AgentCard>
      </DescSection>

      
      <GallerySection>
        <TabsRow>
          <Tab active={galleryTab === 'Photo Gallery'} onClick={() => setGalleryTab('Photo Gallery')}>Photo Gallery</Tab>
          <Tab active={galleryTab === 'Interior'} onClick={() => setGalleryTab('Interior')}>Interior</Tab>
          <Tab active={galleryTab === 'Exterior'} onClick={() => setGalleryTab('Exterior')}>Exterior</Tab>
          <Tab active={galleryTab === 'Floorplan'} onClick={() => setGalleryTab('Floorplan')}>Floorplan</Tab>
        </TabsRow>

        <ImagesRow>
          <GalleryImg src="" alt="gallery 1" />
          <GalleryImg src="" alt="gallery 2" />
          <GalleryImg src="" alt="gallery 3" />
          <GalleryImg src="" alt="gallery 4" />
          <GalleryImg src="" alt="gallery 5" />
        </ImagesRow>
      </GallerySection>

     
      <FloorSection>
        <FloorLeft>
          <FloorTabsRow>
            <FloorTab active={floorTab === 'Floor plan'} onClick={() => setFloorTab('Floor plan')}>Floor plan</FloorTab>
            <FloorTab active={floorTab === 'Garden'} onClick={() => setFloorTab('Garden')}>Garden</FloorTab>
            <FloorTab active={floorTab === 'Security system'} onClick={() => setFloorTab('Security system')}>Security system</FloorTab>
            <FloorTab active={floorTab === 'Swimming pool'} onClick={() => setFloorTab('Swimming pool')}>Swimming pool</FloorTab>
          </FloorTabsRow>

          <FloorContent>
            <FloorImg
              src=""
              alt="floorplan"
            />
            <InfoCardsRow>
              <InfoCard>
                <InfoCardTitle>Kitchen:</InfoCardTitle>
                <InfoCardItem>Modern Kitchen - 20 sqm</InfoCardItem>
                <InfoCardItem>Pantry Storage - 5 sqm</InfoCardItem>
                <InfoCardItem>Direct access to Garden</InfoCardItem>
              </InfoCard>

              <InfoCard>
                <InfoCardTitle>Bedrooms:</InfoCardTitle>
                <InfoCardItem>1 Master Bedroom - 28 sqm</InfoCardItem>
                <InfoCardItem>2 Bedrooms - 18 sqm each</InfoCardItem>
                <InfoCardItem>1 Guest Bedroom - 36 sqm</InfoCardItem>
              </InfoCard>

              <InfoCard>
                <InfoCardTitle>Living and Dining:</InfoCardTitle>
                <InfoCardItem>Main Living Room - 40 sqm</InfoCardItem>
                <InfoCardItem>Formal Dining Area - 22 sqm</InfoCardItem>
                <InfoCardItem>Family Lounge - 18 sqm</InfoCardItem>
              </InfoCard>

              <InfoCard>
                <InfoCardTitle>Bathrooms:</InfoCardTitle>
                <InfoCardItem>1 Master Bathroom - 8 sqm</InfoCardItem>
                <InfoCardItem>2 Bathrooms - 6 sqm each</InfoCardItem>
                <InfoCardItem>1 Guest Bathroom - 3 sqm</InfoCardItem>
              </InfoCard>
            </InfoCardsRow>
          </FloorContent>

          <div style={{ marginTop: '12px', fontFamily: 'sans-serif', fontSize: '0.85rem' }}>
            <strong>Total Area:</strong> 350 sqm
          </div>
        </FloorLeft>

        <AmenitiesCard>
          <AmenitiesTitle>Amenities</AmenitiesTitle>
          <AmenityItem>🏊 Swimming Pool</AmenityItem>
          <AmenityItem>🏋 Gym</AmenityItem>
          <AmenityItem>🏠 Smart Home</AmenityItem>
          <AmenityItem>🔥 BBQ Area</AmenityItem>
        </AmenitiesCard>
      </FloorSection>

      <Footer />
    </div>
  );
}

export default Home;